<template>
  <div>
    <asset-preload-watcher v-if="$route.meta && !$route.meta.ignoreAssetPreloadWatcher && (this.gameRefreshKey !== undefined)" />
    <idle-timeout-controller />
    <router-view :key="$route.fullPath + this.gameRefreshKey" />
    <b-btn
      v-if="multiplayer"
      @click.prevent="toggleChat"
      style="
        position: absolute;
        top: 125px;
        left: 10px;
        transform: scale(0.85);
      "
    >
      {{!chatOpen ? `Chat${messageCountDelta ? ` (${messageCountDelta})` : ''}` : 'Close Chat'}}
    </b-btn>
    <transition enter-active-class="animated fadeInLeft" leave-active-class="animated fadeOutLeft">
      <div v-if="chatOpen" class="chat-overlay">
        <div class="chat-msg-container" ref="chatScroller">
          <div v-for="(msg, idx) of chatMessages" :key="idx" style="margin-bottom: 12.5px;">
            <span style="white-space: pre-wrap;">{{ displayMessage(msg) }}</span>
          </div>
        </div>
        <b-form @submit.prevent="sendChat" style="display: flex; flex-direction: row;">
          <b-input-group>
            <b-form-input placeholder="chat" v-model="messageString"/>
            <b-input-group-append>
              <b-btn
                @click.prevent="sendChat"
                type="submit"
                style="height: 38px; margin-top: -1px;"
              >
                Send
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import AssetPreloadWatcher from '@/components/game/pages/components/AssetPreloadWatcher';
import IdleTimeoutController from '@/components/utility/IdleTimeoutController';

export default {
  components: {
    AssetPreloadWatcher,
    IdleTimeoutController
  },
  props: {
    groupId: String
  },
  data() {
    return {
      isDisconnecting: false,
      isHost: false,
      messageString: '',
      pingInterval: null,
      chatOpen: false,
      lastMessageCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      'activeClass',
      'gameRefreshKey',
      'socket',
      'users',
      'me',
      'multiplayer',
      'chatMessages'
    ]),
    messageCountDelta() {
      const delta = this.chatMessages.length - this.lastMessageCount;
      if (delta > 99) {
        return '99+';
      }
      return delta;
    },
  },
  methods: {
    ...mapMutations([
      'setTargetGroupID',
      'addChatMessage'
    ]),

    ...mapActions([
      'initializeSocket',
      'destroySocket'
    ]),

    initPing() {
      this.disablePing();
      this.pingInterval = setInterval(() => {
        this.broadcastMessage({ command: 'ping' });
      }, 5000);
    },

    disablePing() {
      if (this.pingInterval != null) {
        clearInterval(this.pingInterval);
        this.pingInterval = null;
      }
    },

    sendChat() {
      const toSend = this.messageString.trim();
      if (toSend.length > 0) {
        if (this.socket) {
          this.socket.emit('chat', toSend);
          this.messageString = '';
        }
      }
    },

    toggleChat() {
      this.chatOpen = !(this.chatOpen);
      this.lastMessageCount = this.chatMessages.length;
      this.$nextTick(() => {
        const s = this.$refs.chatScroller;
        if (s) {
          s.scrollTop = s.scrollHeight - s.clientHeight;
        }
      });
    },

    displayMessage(msg) {
      // TODO: this should probably be cached
      const user = this.users[msg.user] || {};
      const nameString = `${user.firstName} (${user.email})`.trim() || msg.user;
      const timestamp = new Date(msg.created);
      const timeString = timestamp.toLocaleString();
      return `${timeString}\n${nameString}:\n${msg.message}`;
    },
  },
  async mounted() {
    setTimeout(() => {
      this.lastMessageCount = this.chatMessages.length;
    }, 200);
    this.setTargetGroupID(this.groupId);
    await this.initializeSocket();
    if (this.socket) {
      this.socket.on('chat', (msg) => {
        console.log(msg);
        // this.messages.push(msg);
        const s = this.$refs.chatScroller;
        const scrolledToBottom = s ? (s.scrollHeight - s.scrollTop - s.clientHeight < 5) : false;
        this.addChatMessage({ chatMessage: msg });
        if (scrolledToBottom) {
          // if scrolled to bottom, keep autoscrolled to bottom when new messages appear
          this.$nextTick(() => {
            if (s) {
              s.scrollTop = s.scrollHeight - s.clientHeight;
            }
          });
        }
      });
    }
  },
  beforeDestroy() {
    if (this.socket) {
      this.destroySocket();
      this.setTargetGroupID(null);
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-overlay {
  position: absolute;
  overflow-y: auto;

  background-color: #171717;
  color: white;

  top: 100px;
  left: 85px;
  width: 375px;
  height: 435px;
  padding: 20px;
  border: 1px solid white;
  border-radius: 10px;
}

.chat-msg-container {
  overflow-y: auto;
  height: 335px;
  width: 100%;
  margin-bottom: 10px;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/networking/SocketIOContainer.vue